import styled from '@emotion/styled'
import { Flex, customStyled } from '@mafc/trolly'
import { margin, MarginProps } from 'styled-system'

export const LayoutChildrenWrapper = styled(Flex)<MarginProps>`
  flex-direction: column;
  max-width: 1258px;
  margin-left: auto;
  margin-right: auto;
  ${margin};
  min-height: 500px;
`

export const LayoutContainer: any = customStyled(Flex)`
  justify-content: flex-start;
  flex-direction: column;
  padding: 0px;
  @media (max-width: ${(props) => props.theme.breakpoints[3]}) {
    padding: 16px 12px;
  }
`

export const LayoutWrapper = styled(Flex)`
  justify-content: center;
`

export const MainContentWrapper: any = customStyled(Flex)`
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  padding: 0px 12px;
  height: 100%;
`

export const MainContentHeader: any = customStyled(Flex)`
  flex-direction: column;
  justify-content: space-between;
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
    flex-direction: row-reverse;
  }
`

export const SearchTitleWrapper: any = customStyled.div`
  max-width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
    max-width: 500px;
  }

  h1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: wrap;
    width: 100%;
  }
`
